import { Link } from "react-router-dom";
import { Swords } from "lucide-react";

export function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-[#2A2A30]/60 bg-[#0A0A0B]/75 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
          <div className="h-9 w-9 rounded-md border border-[#C8AA6E]/40 flex items-center justify-center bg-[#C8AA6E]/10 group-hover:bg-[#C8AA6E]/20 transition-colors">
            <Swords className="h-5 w-5 text-[#C8AA6E]" strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <div className="font-black text-[#F0E6D2] tracking-tight font-[Outfit] text-lg">
              Podziemie<span className="text-[#C8AA6E]">TFT</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#6E6A5E]">
              Turniej · Set 17
            </div>
          </div>
        </Link>
      </div>
    </header>
  );
}
